var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['progress', _vm.size && `progress-${_vm.size}`],style:({ height: _vm.height })},[_vm._t("default",function(){return [_c('CProgressBar',{attrs:{"value":_vm.value}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }